import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import EcommerceSidebar from "./EcommerceSidebar";
import EcommerceCartDrawer from "./EcommerceCartDrawer";
import { CartIcon, MenuIcon, WalletIcon } from "./EcommerceIcons";
import { readCart, saveCart } from "../utils/ecommerceStorage";
import { AppContext } from "../context/AppContext";

const isInactiveAccountStatus = (accountStatus) => {
  if (accountStatus === false || accountStatus === 0) return true;
  if (typeof accountStatus !== "string") return false;
  const normalized = accountStatus.trim().toLowerCase();
  return normalized === "false" || normalized === "0" || normalized === "inactive";
};

export default function EcommerceHeader() {
  const navigate = useNavigate();
  const { isInactive, user } = useContext(AppContext);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [isCartOpen, setCartOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [balance, setBalance] = useState("0");

  useEffect(() => {
    const syncCart = () => setCartItems(readCart());
    const syncBalance = () => setBalance(localStorage.getItem("walletBalance") || "0");
    const openCartDrawer = () => setCartOpen(true);

    syncCart();
    syncBalance();
    window.addEventListener("storage", syncCart);
    window.addEventListener("storage", syncBalance);
    window.addEventListener("ecomm-cart-change", syncCart);
    window.addEventListener("wallet-change", syncBalance);
    window.addEventListener("ecomm-open-cart", openCartDrawer);

    return () => {
      window.removeEventListener("storage", syncCart);
      window.removeEventListener("storage", syncBalance);
      window.removeEventListener("ecomm-cart-change", syncCart);
      window.removeEventListener("wallet-change", syncBalance);
      window.removeEventListener("ecomm-open-cart", openCartDrawer);
    };
  }, []);

  const updateQuantity = (productId, quantity) => {
    const nextCart =
      quantity <= 0
        ? cartItems.filter((item) => item.product.id !== productId)
        : cartItems.map((item) => (item.product.id === productId ? { ...item, quantity } : item));

    setCartItems(nextCart);
    saveCart(nextCart);
  };

  const totalCartCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);
  const isInactiveUser = isInactive === true || isInactiveAccountStatus(user?.accountStatus);
  const handleWalletClick = (event) => {
    if (isInactiveUser) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    navigate("/funds/add");
  };

  return (
    <>
      <header className="ecomm-header">
        <div className="ecomm-header-left">
          <button className="ecomm-menu-btn" aria-label="Open menu" onClick={() => setSidebarOpen(true)}>
            <MenuIcon />
          </button>
          <span className="ecomm-header-title">Gama567</span>
        </div>

        <div className="ecomm-header-right">
          <button className="ecomm-wallet-badge"  disabled={isInactiveUser}>
            <span>₹{balance}</span>
            <WalletIcon />
          </button>

          <button className="ecomm-cart-btn" aria-label="Open cart" onClick={() => navigate("/cart")}>
            <CartIcon />
            {totalCartCount > 0 && <span>{totalCartCount}</span>}
          </button>
        </div>
      </header>

      <EcommerceSidebar isOpen={isSidebarOpen} onClose={() => setSidebarOpen(false)} />
      <EcommerceCartDrawer
        isOpen={isCartOpen}
        onClose={() => setCartOpen(false)}
        cartItems={cartItems}
        onUpdateQuantity={updateQuantity}
        onCheckout={() => {
          setCartOpen(false);
          navigate("/cart");
        }}
      />
    </>
  );
}
